var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBamboo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7415 11.3682H13.5834C13.4522 11.3667 13.3249 11.4127 13.2249 11.4976C13.125 11.5826 13.0591 11.7008 13.0394 11.8305C12.9252 12.6478 12.5192 13.3961 11.8964 13.9374C11.2736 14.4787 10.4761 14.7765 9.65088 14.7758L10.7768 19.9185C12.7553 19.66 14.5836 18.7255 15.9521 17.2733C17.3205 15.8211 18.1448 13.9406 18.2855 11.9502C18.2907 11.8756 18.2805 11.8008 18.2555 11.7303C18.2305 11.6599 18.1913 11.5953 18.1403 11.5407C18.0892 11.4861 18.0275 11.4426 17.9589 11.4129C17.8903 11.3832 17.8163 11.368 17.7415 11.3682Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5456 11.2376L16.5286 6.09497C16.5865 6.04393 16.6329 5.98115 16.6646 5.91082C16.6964 5.84049 16.7128 5.7642 16.7128 5.68703C16.7128 5.60987 16.6964 5.53358 16.6646 5.46325C16.6329 5.39292 16.5865 5.33014 16.5286 5.2791L10.5456 0.128268C10.4665 0.0615242 10.3701 0.0187219 10.2675 0.00488502C10.165 -0.00895185 10.0606 0.00675086 9.96666 0.0501501C9.87273 0.0935493 9.79312 0.162844 9.73719 0.249901C9.68125 0.336958 9.65131 0.438164 9.65088 0.54164V10.8243C9.65131 10.9277 9.68125 11.029 9.73719 11.116C9.79312 11.2031 9.87273 11.2724 9.96666 11.3158C10.0606 11.3592 10.165 11.3749 10.2675 11.361C10.3701 11.3472 10.4665 11.3044 10.5456 11.2376Z",
    fill: "#2684FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08154 12.4913C1.35822 14.5685 2.37945 16.4746 3.95552 17.8556C5.53159 19.2366 7.55535 19.9986 9.65085 20V14.7758C8.74635 14.7758 7.87877 14.417 7.23843 13.7782C6.59808 13.1394 6.23726 12.2727 6.2351 11.3682L1.08154 12.4913Z",
    fill: "url(#paint0_linear_2326_65064)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.2866V11.3681H6.23514C6.2373 10.4636 6.59813 9.59693 7.23847 8.95811C7.87882 8.3193 8.74639 7.96054 9.6509 7.96055L8.52772 2.81787C6.4637 3.08683 4.56599 4.09141 3.18313 5.64712C1.80028 7.20284 1.02511 9.20523 1 11.2866Z",
    fill: "url(#paint1_linear_2326_65064)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2326_65064",
    x1: 5.36756,
    y1: 2.88316,
    x2: 5.36756,
    y2: 14.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2326_65064",
    x1: 5.32681,
    y1: 2.88314,
    x2: 5.32681,
    y2: 14.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBamboo);
export default __webpack_public_path__ + "static/media/bamboo.7d7b5f12a12aef7a416e055b21dd69f1.svg";
export { ForwardRef as ReactComponent };